/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, */

// provides the base for iphones

_.namespace(`mp.marketing.trends.utils`, function(ns) {
  'use strict';
  // Notable iOS events
  // Information about release date can be found at:
  // https://en.wikipedia.org/wiki/IOS_version_history
  // If you want specific beta relase dates, you may need to look at
  // older versions of the wikipedia page
  // For example, iOS 12 Beta 1 release was found at:
  // https://en.wikipedia.org/w/index.php?title=IOS_version_history#iOS_12
  ns.OTHER_IOS = {
    name: `Other`,
    release_dates: [],
    regex: /^iOS [0-9]+$/,
  };
  ns.IOS_14 = {
    name: `iOS 14`,
    release_dates: [
      {
        text: `Beta 1`,
        value: new Date(2020, 6, 9),
      },
      {
        text: `Release`,
        value: new Date(2020, 8, 16),
      },
    ],
    regex: /^14\./,
  };
  ns.IOS_13 = {
    name: `iOS 13`,
    release_dates: [
      {
        text: `Beta 1`,
        value: new Date(2019, 8, 10),
      },
      {
        text: `Release`,
        value: new Date(2019, 8, 19),
      },
    ],
    regex: /^13\./,
  };
  ns.IOS_12 = {
    name: `iOS 12`,
    release_dates: [
      {
        text: `Beta 1`,
        value: new Date(2018, 5, 25),
      },
      {
        text: `Release`,
        value: new Date(2018, 8, 17),
      },
    ],
    regex: /^12\./,
  };
  ns.IOS_11 = {
    name: `iOS 11`,
    release_dates: [
      {
        text: `Beta 1`,
        value: new Date(2017, 5, 5),
      },
      {
        text: `Release`,
        value: new Date(2017, 8, 19, 3),
      },
    ],
    regex: /^11\./,
  };
  ns.IOS_10 = {
    name: `iOS 10`,
    release_dates: [
      {
        text: `Beta 1`,
        value: new Date(2016, 6, 7),
      },
      {
        text: `Release`,
        value: new Date(2016, 8, 13),
      },
    ],
    regex: /^10\./,
  };
  ns.IOS_9 = {
    name: `iOS 9`,
    release_dates: [
      {
        text: `Beta 4`,
        value: new Date(2015, 6, 21),
      },
      {
        text: `Release`,
        value: new Date(2016, 8, 16),
      },
    ],
    regex: /^9\./,
  };
  ns.IOS_8 = {
    name: `iOS 8`,
    release_dates: [
      {
        text: `Release`,
        value: new Date(2014, 8, 17),
      },
    ],
    regex: /^8\./,
  };
  ns.IOS_7 = {
    name: `iOS 7`,
    release_dates: [
      {
        text: `Release`,
        value: new Date(2013, 8, 18),
      },
    ],
    regex: /^7\./,
  };
  ns.IOS_6 = {
    name: `iOS 6`,
    release_dates: [
      {
        text: `Release`,
        value: new Date(2012, 8, 19),
      },
    ],
    regex: /^6\./,
  };
  ns.IOS_QUERY = `ios_fragmentation`;
});

}.call(window));